module.exports = __webpack_public_path__ + "static/img/logo20260818.6da7faa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/logo20260818.png
// module id = aO6A
// module chunks = 23